export {default} from './LanguagesListModel';
export * from './LanguagesListModel';



// WEBPACK FOOTER //
// ./src/models/LanguagesListModel/index.ts